import axios from "../../../../../../api/axiosInstance";
import { GetHubDashboardResponse } from "./types";

export const getHubDashboard = async (): Promise<GetHubDashboardResponse> => {
  const response = await axios.get<GetHubDashboardResponse>(
    "/api/private/hub/dashboard",
  );
  return response.data;
};
